'use client';
import { jsxs, Fragment, jsx } from 'react/jsx-runtime';
import { U as UploadButton } from './button-client-DaYiwH1a.js';
import { U as UploadDropzone } from './dropzone-client-rGcERk9B.js';

function Uploader(props) {
    return /*#__PURE__*/ jsxs(Fragment, {
        children: [
            /*#__PURE__*/ jsxs("div", {
                className: "flex flex-col items-center justify-center gap-4",
                children: [
                    /*#__PURE__*/ jsx("span", {
                        className: "text-center text-4xl font-bold",
                        children: `Upload a file using a button:`
                    }),
                    /*#__PURE__*/ jsx(UploadButton, {
                        ...props
                    })
                ]
            }),
            /*#__PURE__*/ jsxs("div", {
                className: "flex flex-col items-center justify-center gap-4",
                children: [
                    /*#__PURE__*/ jsx("span", {
                        className: "text-center text-4xl font-bold",
                        children: `...or using a dropzone:`
                    }),
                    /*#__PURE__*/ jsx(UploadDropzone, {
                        ...props
                    })
                ]
            })
        ]
    });
}

export { Uploader as U };
